import { TabsProps } from '@mui/material';
import { TabConfigItem } from '../../../../@types';
import GolaTabs from './Tabs';

type GolaUserListTabsProps = TabsProps & {
  tabConfig: TabConfigItem<string>[];
};

const UserListTabs = (props: GolaUserListTabsProps) => <GolaTabs {...props} customIndicatorColor='info' />;

export default UserListTabs;
